export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14590.c8eb704e.jpg";